import { render, staticRenderFns } from "./SalesReportConfirm.vue?vue&type=template&id=ddb78b8a&"
import script from "./SalesReportConfirm.vue?vue&type=script&lang=js&"
export * from "./SalesReportConfirm.vue?vue&type=script&lang=js&"
import style0 from "./SalesReportConfirm.vue?vue&type=style&index=0&id=ddb78b8a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports